/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Group data transfer object with audit information
 * @export
 * @interface GroupDto
 */
export interface GroupDto {
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupDto
     */
    roleIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupDto
     */
    userIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    tenantId?: string;
    /**
     * Tenant name this group belongs to
     * @type {string}
     * @memberof GroupDto
     */
    tenantName?: string;
    /**
     * Tenant slug this group belongs to
     * @type {string}
     * @memberof GroupDto
     */
    tenantSlug?: string;
    /**
     * Customer ID associated with the tenant
     * @type {string}
     * @memberof GroupDto
     */
    customerId?: string;
    /**
     * Customer name associated with the tenant
     * @type {string}
     * @memberof GroupDto
     */
    customerName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDto
     */
    active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GroupDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GroupDto
     */
    updated?: Date;
    /**
     * User ID who created this record
     * @type {string}
     * @memberof GroupDto
     */
    createdByUserId?: string;
    /**
     * Username who created this record
     * @type {string}
     * @memberof GroupDto
     */
    createdByUsername?: string;
    /**
     * User ID who last updated this record
     * @type {string}
     * @memberof GroupDto
     */
    updatedByUserId?: string;
    /**
     * Username who last updated this record
     * @type {string}
     * @memberof GroupDto
     */
    updatedByUsername?: string;
    /**
     * When this record was last updated (UTC)
     * @type {Date}
     * @memberof GroupDto
     */
    updatedAt?: Date;
    /**
     * When this record was created (UTC)
     * @type {Date}
     * @memberof GroupDto
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the GroupDto interface.
 */
export function instanceOfGroupDto(value: object): value is GroupDto {
    return true;
}

export function GroupDtoFromJSON(json: any): GroupDto {
    return GroupDtoFromJSONTyped(json, false);
}

export function GroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'roleIds': json['roleIds'] == null ? undefined : json['roleIds'],
        'userIds': json['userIds'] == null ? undefined : json['userIds'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'tenantName': json['tenantName'] == null ? undefined : json['tenantName'],
        'tenantSlug': json['tenantSlug'] == null ? undefined : json['tenantSlug'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'customerName': json['customerName'] == null ? undefined : json['customerName'],
        'active': json['active'] == null ? undefined : json['active'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'createdByUserId': json['createdByUserId'] == null ? undefined : json['createdByUserId'],
        'createdByUsername': json['createdByUsername'] == null ? undefined : json['createdByUsername'],
        'updatedByUserId': json['updatedByUserId'] == null ? undefined : json['updatedByUserId'],
        'updatedByUsername': json['updatedByUsername'] == null ? undefined : json['updatedByUsername'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function GroupDtoToJSON(json: any): GroupDto {
    return GroupDtoToJSONTyped(json, false);
}

export function GroupDtoToJSONTyped(value?: GroupDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'displayName': value['displayName'],
        'description': value['description'],
        'roleIds': value['roleIds'],
        'userIds': value['userIds'],
        'tenantId': value['tenantId'],
        'tenantName': value['tenantName'],
        'tenantSlug': value['tenantSlug'],
        'customerId': value['customerId'],
        'customerName': value['customerName'],
        'active': value['active'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'createdByUserId': value['createdByUserId'],
        'createdByUsername': value['createdByUsername'],
        'updatedByUserId': value['updatedByUserId'],
        'updatedByUsername': value['updatedByUsername'],
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

